import firebase from 'firebase/app';
import 'firebase/firestore';

interface EventModel {
  // TODO: fill the event model
  name: string;
}

export default class EventApi {
  static async retrieve(): Promise<EventModel> {
    const db = firebase.firestore();

    const eventId = 'rainform';

    const docSnp = await db.collection('events').doc(eventId).get();
    const event = docSnp.data() as EventModel;
    return event;
  }
}
